var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_big"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7713 18.2059L5.2941 6.72875C4.90197 6.33661 4.90197 5.68624 5.2941 5.2941C5.68624 4.90197 6.33661 4.90197 6.72875 5.2941L18.2059 16.7713C18.598 17.1634 18.598 17.8138 18.2059 18.2059C17.8138 18.598 17.1634 18.598 16.7713 18.2059Z",
    fill: "#8F98A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2941 18.2059C4.90197 17.8138 4.90197 17.1634 5.2941 16.7713L16.7713 5.2941C17.1634 4.90197 17.8138 4.90197 18.2059 5.2941C18.598 5.68624 18.598 6.33661 18.2059 6.72875L6.72875 18.2059C6.33661 18.598 5.68624 18.598 5.2941 18.2059Z",
    fill: "#8F98A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBig);
export default __webpack_public_path__ + "static/media/close_big.de0bdf64e62f1ef8df8dcbe0a922adb2.svg";
export { ForwardRef as ReactComponent };